module.exports = __webpack_public_path__ + "static/aduanal-side-thumb-d56f53bea1174ea2c5ac9f69575805bd.jpg";